<template>
  <div>
    <div
      :class="[{ 'promo-item': oi.promo != null }, 'ordered-item']"
      v-for="(oi, index) in $store.state.order.orderItems"
      :key="index"
    >
      <v-row>
        <v-col cols="1" class="item-qty">
          <div v-if="oi.promo == null || oi.bundleItems.length == 0 || oi.qty > 1">{{ oi.qty }}</div>
        </v-col>

        <v-col class="item-descr">
          <div :class="[{ 'promo-descr': oi.promo != null }]">
            <!-- <span><v-icon>mdi-ticket-percent-outline</v-icon></span> -->

            <span v-if="$store.state.descrIndex == 1">{{ oi.ord_descr1 }}</span>
            <span v-else-if="$store.state.descrIndex == 2">{{ oi.ord_descr2 }}</span>
            <span v-else>{{ oi.ord_descr }}</span>
          </div>

          <div v-if="oi.item != null && oi.item.scalable && oi.item.weight > 0" class="item-scale">
            {{ oi.item.weight }} {{ oi.item.weightUnit }} @ {{ oi.price | currency }}
          </div>

          <div v-if="!isPaymentPage() && $store.state.showItemBarcode && oi.barcode != ''" class="item-barcode">
            {{ oi.barcode }}
          </div>
          <div
            v-if="
              oi.promo != null &&
                oi.promo.MinAmount != null &&
                oi.promo.MinAmount > 0 &&
                $store.state.order.subtotal - oi.extended < oi.promo.MinAmount
            "
            class="item-remark"
          >
            {{ $t("promo_valid_min_amount", { amount: oi.promo.MinAmount }) }}
          </div>
          <div v-if="oi.remark != ''" class="item-remark">
            {{ oi.remark }}
          </div>
        </v-col>

        <v-col v-show="oi.promo == null" cols="4" class="text-right item-price">
          {{ getOrderItemExtended(oi) | currency }}
        </v-col>
      </v-row>

      <div v-if="oi.bundleItems.length > 0" class="bundle-items">
        <div v-for="(bi, biIndex) in oi.bundleItems" :key="biIndex">
          <v-row>
            <v-col cols="1" class="item-qty">
              <div v-if="oi.promo != null || bi.orderItem.qty > 1">{{ bi.orderItem.qty }}</div>
            </v-col>
            <v-col>
              <div class="item-descr">
                <span v-if="$store.state.descrIndex == 1">
                  {{ bi.orderItem.ord_descr1 }}
                </span>
                <span v-else-if="$store.state.descrIndex == 2">
                  {{ bi.orderItem.ord_descr2 }}
                </span>
                <span v-else>
                  {{ bi.orderItem.ord_descr }}
                </span>
              </div>
              <div v-if="bi.orderItem.remark != ''" class="item-remark">
                {{ bi.orderItem.remark }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right item-price">
              <div v-show="oi.promo != null">{{ getOrderItemTotal(bi.orderItem) | currency }}</div>
            </v-col>
          </v-row>

          <v-row v-if="getOrderItemDiscountValue(bi.orderItem) > 0">
            <v-col cols="1" class="item-qty"> </v-col>
            <v-col>
              <span v-if="bi.orderItem.itemDiscountRate > 0">{{ bi.orderItem.itemDiscountRate }}% </span
              >{{ $t("discount") }}
            </v-col>
            <v-col cols="4" class="text-right item-price">
              <div v-show="oi.promo != null" class="text-right item-price">
                {{ -getOrderItemDiscountValue(bi.orderItem) | currency }}
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <v-row v-if="oi.redeemItem">
        <v-col cols="1"></v-col>
        <v-col class="item-redeem"
          ><span class="item-redeem-title">{{ $t("redeem") }} : </span
          ><span class="item-redeem-value">{{ oi.redeemPoints * oi.qty }} pts</span></v-col
        >
      </v-row>

      <v-row v-if="!isPaymentPage()">
        <v-col cols="1"></v-col>
        <v-col>
          <v-chip
            v-show="editButtonVisible && (oi.promo == null || oi.bundleItems.length > 0)"
            small
            color="secondary"
            text-color="secondaryText"
            class="item-edit"
            @click="editItem(oi)"
          >
            {{ $t("edit") }}
          </v-chip>
          <v-chip small color="accent" text-color="accentText" class="item-remove" @click="removeItem(oi)">
            {{ $t("remove") }}
          </v-chip>
          <v-chip small color="info" text-color="infoText" v-if="oi.cbRefID > 0" class="item-combo">
            <span>{{
              $t("combo_id", {
                comboId: $store.state.order.cbRefIDs.indexOf(oi.cbRefID) + 1,
              })
            }}</span>
          </v-chip>
        </v-col>
      </v-row>
    </div>

    <div v-show="addPromoAllowed">
      <v-row>
        <v-col cols="1"></v-col>
        <v-col cols="5" sm="4" md="3" lg="2"
          ><v-text-field
            v-model="promoCode"
            :label="$t('checkout.add_promo_code')"
            x-placeholder="$t('checkout.enter_promo_code')"
          ></v-text-field
        ></v-col>
        <v-col class="d-flex align-center">
          <v-btn small color="secondary" class="secondaryText--text" @click="addPromo">{{
            $t("checkout.add_promo_button")
          }}</v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="order-total-box">
      <v-row align="center" class="subtotal">
        <v-col :cols="cartOnRightShown() ? '6' : '8'" class="t-title">
          {{ $t("subtotal") }}
        </v-col>
        <v-col :cols="cartOnRightShown() ? '6' : '4'" class="t-value">
          {{ $store.state.order.subtotal | currency }}
        </v-col>
      </v-row>

      <v-row v-if="$store.state.order.discountValue > 0" align="center" class="discount">
        <v-col :cols="cartOnRightShown() ? '6' : '8'" class="t-title">
          <span v-if="$store.state.order.discountRate > 0">{{ $store.state.order.discountRate }}% </span
          >{{ $t("discount") }}
        </v-col>
        <v-col :cols="cartOnRightShown() ? '6' : '4'" class="t-value">
          {{ -$store.state.order.discountValue | currency }}
        </v-col>
      </v-row>

      <v-row v-if="$store.state.order.deliveryValue > 0" align="center" class="delivery">
        <v-col :cols="cartOnRightShown() ? '6' : '8'" class="t-title">
          {{ $t("delivery_charge") }}
        </v-col>
        <v-col :cols="cartOnRightShown() ? '6' : '4'" class="t-value">
          {{ $store.state.order.deliveryValue | currency }}
        </v-col>
      </v-row>

      <v-row v-if="$store.state.order.serviceValue > 0" align="center" class="service">
        <v-col :cols="cartOnRightShown() ? '6' : '8'" class="t-title">
          <span v-if="$store.state.order.serviceRate > 0">{{ $store.state.order.serviceRate }}% </span
          >{{ $t("service_charge") }}
        </v-col>
        <v-col :cols="cartOnRightShown() ? '6' : '4'" class="t-value">
          {{ $store.state.order.serviceValue | currency }}
        </v-col>
      </v-row>    

      <v-row align="center" class="tax">
        <v-col :cols="cartOnRightShown() ? '6' : '8'" class="t-title">
          {{ $t("tax") }}
        </v-col>
        <v-col :cols="cartOnRightShown() ? '6' : '4'" class="t-value">
          {{ $store.state.order.tax | currency }}
        </v-col>
      </v-row>

      <v-row align="center" class="total">
        <v-col :cols="cartOnRightShown() ? '6' : '8'" class="t-title">
          {{ $t("total") }}
        </v-col>
        <v-col :cols="cartOnRightShown() ? '6' : '4'" class="t-value">
          {{ $store.state.order.total | currency }}
        </v-col>
      </v-row>

      <v-row v-if="isPaymentPage()" class="tips">
        <v-col :cols="cartOnRightShown() ? '6' : '8'" class="t-title">
          {{ $t("tips") }}
        </v-col>
        <v-col :cols="cartOnRightShown() ? '6' : '4'" class="t-value">
          {{ $store.state.order.tips | currency }}
        </v-col>
      </v-row>

      <v-row v-if="isPaymentPage()" class="total-to-pay">
        <v-col :cols="cartOnRightShown() ? '6' : '8'" class="t-title">
          {{ $t("total_to_pay") }}
        </v-col>
        <v-col :cols="cartOnRightShown() ? '6' : '4'" class="t-value">
          {{ ($store.state.order.total + $store.state.order.tips) | currency }}
        </v-col>
      </v-row>

      <v-row align="center" class="total-currency">
        <v-col :cols="cartOnRightShown() ? '6' : '8'" class="t-title"> </v-col>
        <v-col :cols="cartOnRightShown() ? '6' : '4'" class="t-value">
          {{ $store.state.order.currency }}
        </v-col>
      </v-row>

      <div
        class="points"
        v-if="
          $store.state.member != null &&
            $store.state.order.redeemedPointsTotal > 0
        "
      >
        <v-row>
          <v-col cols="1"></v-col>
          <v-col class="pts-title">
            {{ $t("points") }}
          </v-col>
        </v-row>
        <v-row class="point-balance">
          <v-col cols="1"></v-col>
          <v-col>
            <span class="t-title">{{ $t("member_point_balance") }} : </span>
            <span class="t-value">{{ $store.state.member.MemberPointBalance }} pts</span>
          </v-col>
        </v-row>
        <v-row class="point-redeem">
          <v-col cols="1"></v-col>
          <v-col>
            <span class="t-title">{{ $t("member_point_redeemed") }} : </span>
            <span class="t-value">{{ $store.state.order.redeemedPointsTotal }} pts</span>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentRouteName: String,
  },
  data() {
    return {
      promoCode: "",
    };
  },

  activated() {
    console.log(this.$router.currentRoute.name);
    this.promoCode = "";
  },

  computed: {
    addPromoAllowed() {
      if (
        this.$store.state.order.orderType != this.$store.state.OT_DINEIN &&
        this.currentRouteName == "Checkout" &&
        this.$store.state.member != null &&
        this.$store.state.promos.length > 0
      ) {
        let promoOi = this.$store.state.order.orderItems.find(oi => oi.promo != null);
        return promoOi == null;
      } else return false;
    },
  },

  methods: {
    editButtonVisible() {
      return (
        this.currentRouteName == "Checkout" ||
        this.currentRouteName == "MenuFull" ||
        this.currentRouteName == "MenuCategory" ||
        this.currentRouteName == "MenuItem"
      );
    },

    isPaymentPage() {
      return this.currentRouteName == "Payment";
    },

    editItem(oi) {
      let params = { orderItem: oi };
      if (oi.bundleItems.length > 0 && this.$store.state.serverBuildNo >= 143) {
        this.navName("OrderBundle", params);
      } else {
        this.navName("Order", params);
      }
    },

    removeItem(oi) {
      let linkedOrderItem = this.getLinkedOrderItem(oi);
      this.unlinkCombo(oi);

      const index = this.$store.state.order.orderItems.indexOf(oi);
      this.$store.state.order.orderItems.splice(index, 1);

      this.linkCombo(linkedOrderItem);

      if (this.$store.state.order.orderItems.length == 0) {
        this.$store.state.order.address = null;
        this.$store.state.order.deliveryValueByAddress = 0;
        this.$store.state.order.deliveryWithhold = 0;
      }

      this.calculateTotal();
      this.setOrderToStorage();
    },

    async addPromo() {
      console.log(this.promoCode);

      let getResp = await this.rest_getMemberPromo(this.$store.state.member.MemberCode, this.promoCode);
      let promo = null;
      if (getResp.result == "ok") {
        promo = getResp.record;

        this.addExInfoToPromo(promo);
      }

      if (promo != null) {
        let promoValidated = await this.validatePromo(promo);
        if (!promoValidated) return;

        this.addPromoToCart(promo);
      } else {
        this.$root.messageDialog(
          this.$t("error_alert_title"),
          "",
          this.$t("error_promo_redeemed", { promo: this.promoCode })
        );
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item-barcode {
  font-size: 0.9em;
  color: var(--v-secondary-base);
}

.item-remark {
  font-size: 1em;
  color: var(--v-accent-base);
}

.item-edit {
  margin-right: 8px;
}

.item-remove {
  margin-right: 8px;
}

.item-combo {
  margin-right: 8px;
}

.ordered-item {
  .item-descr {
    white-space: pre-line !important;
  }

  .item-scale {
    font-size: 0.9em;
    padding: 0px 4px;
    padding-bottom: 4px;
    white-space: pre-line !important;
    overflow: auto;
  }  

  .promo-descr {
    //color: var(--v-accent-base);
    font-weight: bold;
    //font-size: 1.1em;
    //text-decoration: underline;
    //text-decoration-color: red;
  }

  .bundle-items {
    .col {
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
}

.promo-item {
}

.order-total-box {
  padding: 20px 0px;
  border-bottom-color: rgb(200, 200, 200);
  border-bottom-style: solid;
  border-bottom-width: 1px;

  [class*="col-"] {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .t-title {
    text-align: right;
  }

  .t-value {
    text-align: right;
  }

  .total {
    font-weight: bold;
    color: var(--v-accent-base);
  }

  .tips {
    font-weight: bold;
  }

  .total-to-pay {
    font-weight: bold;
    color: var(--v-accent-base);
  }

  .total-currency {
    .col {
      padding-top: 0px;
      padding-bottom: 0px;
    }
    color: var(--v-accent-base);
    text-align: right;
    font-size: 0.8em;
    font-weight: normal;
  }

  .points {
    .col {
      padding: 4px 0px;
    }

    .pts-title {
      color: var(--v-accent-base);
      font-weight: bold;
      font-size: 1em !important;
    }

    .point-balance {
      font-size: 1em;
      .t-title {
        margin-left: 10px;
        font-weight: normal;
      }
      .t-value {
        font-weight: bold;
      }
    }

    .point-redeem {
      font-size: 1em;
      .t-title {
        margin-left: 10px;
        font-weight: normal;
      }
      .t-value {
        font-weight: bold;
      }
    }
  }
}
</style>
